"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTemplatesApi = exports.ProductTemplatesApiFactory = exports.ProductTemplatesApiFp = exports.ProductTemplatesApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * ProductTemplatesApi - axios parameter creator
 * @export
 */
const ProductTemplatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} [productEntryData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceCreateProductEntry: (productTemplateRef_1, productEntryData_1, ...args_1) => __awaiter(this, [productTemplateRef_1, productEntryData_1, ...args_1], void 0, function* (productTemplateRef, productEntryData, options = {}) {
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourceCreateProductEntry', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/product-templates/{productTemplateRef}/data`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(productEntryData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceDeleteProductEntriesByFilter: (productTemplateRef_2, dateFrom_1, dateTo_1, filter_1, ...args_2) => __awaiter(this, [productTemplateRef_2, dateFrom_1, dateTo_1, filter_1, ...args_2], void 0, function* (productTemplateRef, dateFrom, dateTo, filter, options = {}) {
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourceDeleteProductEntriesByFilter', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/product-templates/{productTemplateRef}/delete-by-filter`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString() :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString() :
                    dateTo;
            }
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} [productEntryData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceDeleteProductEntry: (entryId_1, productTemplateRef_3, productEntryData_2, ...args_3) => __awaiter(this, [entryId_1, productTemplateRef_3, productEntryData_2, ...args_3], void 0, function* (entryId, productTemplateRef, productEntryData, options = {}) {
            // verify required parameter 'entryId' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourceDeleteProductEntry', 'entryId', entryId);
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourceDeleteProductEntry', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/product-templates/{productTemplateRef}/{entryId}`
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)))
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(productEntryData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get data for bubble/scatter chart
         * @param {number} id
         * @param {string} [colorAttr]
         * @param {number} [nCount]
         * @param {string} [xAttr]
         * @param {string} [yAttr]
         * @param {string} [zAttr]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetBubbleChartData: (id_1, colorAttr_1, nCount_1, xAttr_1, yAttr_1, zAttr_1, ...args_4) => __awaiter(this, [id_1, colorAttr_1, nCount_1, xAttr_1, yAttr_1, zAttr_1, ...args_4], void 0, function* (id, colorAttr, nCount, xAttr, yAttr, zAttr, options = {}) {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourceGetBubbleChartData', 'id', id);
            const localVarPath = `/product-templates/{id}/bubbleData`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (colorAttr !== undefined) {
                localVarQueryParameter['colorAttr'] = colorAttr;
            }
            if (nCount !== undefined) {
                localVarQueryParameter['nCount'] = nCount;
            }
            if (xAttr !== undefined) {
                localVarQueryParameter['xAttr'] = xAttr;
            }
            if (yAttr !== undefined) {
                localVarQueryParameter['yAttr'] = yAttr;
            }
            if (zAttr !== undefined) {
                localVarQueryParameter['zAttr'] = zAttr;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} ref
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetEntryId: (ref_1, ...args_5) => __awaiter(this, [ref_1, ...args_5], void 0, function* (ref, options = {}) {
            // verify required parameter 'ref' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourceGetEntryId', 'ref', ref);
            const localVarPath = `/product-templates/{ref}/id`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateData: (productTemplateRef_4, dateFrom_2, dateTo_2, filter_2, ...args_6) => __awaiter(this, [productTemplateRef_4, dateFrom_2, dateTo_2, filter_2, ...args_6], void 0, function* (productTemplateRef, dateFrom, dateTo, filter, options = {}) {
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourceGetProductTemplateData', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/product-templates/{productTemplateRef}/data`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString() :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString() :
                    dateTo;
            }
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateDataAsForeignKeys: (productTemplateRef_5, ...args_7) => __awaiter(this, [productTemplateRef_5, ...args_7], void 0, function* (productTemplateRef, options = {}) {
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourceGetProductTemplateDataAsForeignKeys', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/product-templates/{productTemplateRef}/asForeignKeys`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateDataPaginated: (productTemplateRef_6, dateFrom_3, dateTo_3, filter_3, offset_1, pageSize_1, ...args_8) => __awaiter(this, [productTemplateRef_6, dateFrom_3, dateTo_3, filter_3, offset_1, pageSize_1, ...args_8], void 0, function* (productTemplateRef, dateFrom, dateTo, filter, offset, pageSize, options = {}) {
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourceGetProductTemplateDataPaginated', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/product-templates/v2/{productTemplateRef}/data`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString() :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString() :
                    dateTo;
            }
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateInfo: (id_2, ...args_9) => __awaiter(this, [id_2, ...args_9], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourceGetProductTemplateInfo', 'id', id);
            const localVarPath = `/product-templates/infos/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateInfos: (...args_10) => __awaiter(this, [...args_10], void 0, function* (options = {}) {
            const localVarPath = `/product-templates/infos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} [productEntryData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourcePatchProductEntry: (entryId_2, productTemplateRef_7, productEntryData_3, ...args_11) => __awaiter(this, [entryId_2, productTemplateRef_7, productEntryData_3, ...args_11], void 0, function* (entryId, productTemplateRef, productEntryData, options = {}) {
            // verify required parameter 'entryId' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourcePatchProductEntry', 'entryId', entryId);
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourcePatchProductEntry', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/product-templates/{productTemplateRef}/{entryId}`
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)))
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(productEntryData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} attribute
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceSignProductEntry: (attribute_1, entryId_3, productTemplateRef_8, ...args_12) => __awaiter(this, [attribute_1, entryId_3, productTemplateRef_8, ...args_12], void 0, function* (attribute, entryId, productTemplateRef, options = {}) {
            // verify required parameter 'attribute' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourceSignProductEntry', 'attribute', attribute);
            // verify required parameter 'entryId' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourceSignProductEntry', 'entryId', entryId);
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourceSignProductEntry', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/product-templates/{productTemplateRef}/{entryId}/{attribute}/sign`
                .replace(`{${"attribute"}}`, encodeURIComponent(String(attribute)))
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)))
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdateProductEntriesRequest} [updateProductEntriesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceUpdateData: (updateProductEntriesRequest_1, ...args_13) => __awaiter(this, [updateProductEntriesRequest_1, ...args_13], void 0, function* (updateProductEntriesRequest, options = {}) {
            const localVarPath = `/product-templates/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateProductEntriesRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PythonProductTemplateData} [pythonProductTemplateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceUpdateDataBatch: (pythonProductTemplateData_1, ...args_14) => __awaiter(this, [pythonProductTemplateData_1, ...args_14], void 0, function* (pythonProductTemplateData, options = {}) {
            const localVarPath = `/product-templates/update-data-batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pythonProductTemplateData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceWipeAllProductEntries: (productTemplateRef_9, ...args_15) => __awaiter(this, [productTemplateRef_9, ...args_15], void 0, function* (productTemplateRef, options = {}) {
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('productTemplateResourceWipeAllProductEntries', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/product-templates/{productTemplateRef}/wipe-all`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ProductTemplatesApiAxiosParamCreator = ProductTemplatesApiAxiosParamCreator;
/**
 * ProductTemplatesApi - functional programming interface
 * @export
 */
const ProductTemplatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ProductTemplatesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} [productEntryData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceCreateProductEntry(productTemplateRef, productEntryData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourceCreateProductEntry(productTemplateRef, productEntryData, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourceCreateProductEntry']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceDeleteProductEntriesByFilter(productTemplateRef, dateFrom, dateTo, filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourceDeleteProductEntriesByFilter(productTemplateRef, dateFrom, dateTo, filter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourceDeleteProductEntriesByFilter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} [productEntryData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceDeleteProductEntry(entryId, productTemplateRef, productEntryData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourceDeleteProductEntry(entryId, productTemplateRef, productEntryData, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourceDeleteProductEntry']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get data for bubble/scatter chart
         * @param {number} id
         * @param {string} [colorAttr]
         * @param {number} [nCount]
         * @param {string} [xAttr]
         * @param {string} [yAttr]
         * @param {string} [zAttr]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetBubbleChartData(id, colorAttr, nCount, xAttr, yAttr, zAttr, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourceGetBubbleChartData(id, colorAttr, nCount, xAttr, yAttr, zAttr, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourceGetBubbleChartData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} ref
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetEntryId(ref, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourceGetEntryId(ref, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourceGetEntryId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateData(productTemplateRef, dateFrom, dateTo, filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourceGetProductTemplateData(productTemplateRef, dateFrom, dateTo, filter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourceGetProductTemplateData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateDataAsForeignKeys(productTemplateRef, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourceGetProductTemplateDataAsForeignKeys(productTemplateRef, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourceGetProductTemplateDataAsForeignKeys']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateDataPaginated(productTemplateRef, dateFrom, dateTo, filter, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourceGetProductTemplateDataPaginated(productTemplateRef, dateFrom, dateTo, filter, offset, pageSize, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourceGetProductTemplateDataPaginated']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateInfo(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourceGetProductTemplateInfo(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourceGetProductTemplateInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateInfos(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourceGetProductTemplateInfos(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourceGetProductTemplateInfos']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} [productEntryData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourcePatchProductEntry(entryId, productTemplateRef, productEntryData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourcePatchProductEntry(entryId, productTemplateRef, productEntryData, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourcePatchProductEntry']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} attribute
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceSignProductEntry(attribute, entryId, productTemplateRef, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourceSignProductEntry(attribute, entryId, productTemplateRef, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourceSignProductEntry']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {UpdateProductEntriesRequest} [updateProductEntriesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceUpdateData(updateProductEntriesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourceUpdateData(updateProductEntriesRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourceUpdateData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PythonProductTemplateData} [pythonProductTemplateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceUpdateDataBatch(pythonProductTemplateData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourceUpdateDataBatch(pythonProductTemplateData, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourceUpdateDataBatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceWipeAllProductEntries(productTemplateRef, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productTemplateResourceWipeAllProductEntries(productTemplateRef, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductTemplatesApi.productTemplateResourceWipeAllProductEntries']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.ProductTemplatesApiFp = ProductTemplatesApiFp;
/**
 * ProductTemplatesApi - factory interface
 * @export
 */
const ProductTemplatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ProductTemplatesApiFp)(configuration);
    return {
        /**
         *
         * @param {ProductTemplatesApiProductTemplateResourceCreateProductEntryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceCreateProductEntry(requestParameters, options) {
            return localVarFp.productTemplateResourceCreateProductEntry(requestParameters.productTemplateRef, requestParameters.productEntryData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductTemplatesApiProductTemplateResourceDeleteProductEntriesByFilterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceDeleteProductEntriesByFilter(requestParameters, options) {
            return localVarFp.productTemplateResourceDeleteProductEntriesByFilter(requestParameters.productTemplateRef, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductTemplatesApiProductTemplateResourceDeleteProductEntryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceDeleteProductEntry(requestParameters, options) {
            return localVarFp.productTemplateResourceDeleteProductEntry(requestParameters.entryId, requestParameters.productTemplateRef, requestParameters.productEntryData, options).then((request) => request(axios, basePath));
        },
        /**
         * Get data for bubble/scatter chart
         * @param {ProductTemplatesApiProductTemplateResourceGetBubbleChartDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetBubbleChartData(requestParameters, options) {
            return localVarFp.productTemplateResourceGetBubbleChartData(requestParameters.id, requestParameters.colorAttr, requestParameters.nCount, requestParameters.xAttr, requestParameters.yAttr, requestParameters.zAttr, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductTemplatesApiProductTemplateResourceGetEntryIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetEntryId(requestParameters, options) {
            return localVarFp.productTemplateResourceGetEntryId(requestParameters.ref, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductTemplatesApiProductTemplateResourceGetProductTemplateDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateData(requestParameters, options) {
            return localVarFp.productTemplateResourceGetProductTemplateData(requestParameters.productTemplateRef, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductTemplatesApiProductTemplateResourceGetProductTemplateDataAsForeignKeysRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateDataAsForeignKeys(requestParameters, options) {
            return localVarFp.productTemplateResourceGetProductTemplateDataAsForeignKeys(requestParameters.productTemplateRef, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductTemplatesApiProductTemplateResourceGetProductTemplateDataPaginatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateDataPaginated(requestParameters, options) {
            return localVarFp.productTemplateResourceGetProductTemplateDataPaginated(requestParameters.productTemplateRef, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.filter, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductTemplatesApiProductTemplateResourceGetProductTemplateInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateInfo(requestParameters, options) {
            return localVarFp.productTemplateResourceGetProductTemplateInfo(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceGetProductTemplateInfos(options) {
            return localVarFp.productTemplateResourceGetProductTemplateInfos(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductTemplatesApiProductTemplateResourcePatchProductEntryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourcePatchProductEntry(requestParameters, options) {
            return localVarFp.productTemplateResourcePatchProductEntry(requestParameters.entryId, requestParameters.productTemplateRef, requestParameters.productEntryData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductTemplatesApiProductTemplateResourceSignProductEntryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceSignProductEntry(requestParameters, options) {
            return localVarFp.productTemplateResourceSignProductEntry(requestParameters.attribute, requestParameters.entryId, requestParameters.productTemplateRef, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductTemplatesApiProductTemplateResourceUpdateDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceUpdateData(requestParameters = {}, options) {
            return localVarFp.productTemplateResourceUpdateData(requestParameters.updateProductEntriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductTemplatesApiProductTemplateResourceUpdateDataBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceUpdateDataBatch(requestParameters = {}, options) {
            return localVarFp.productTemplateResourceUpdateDataBatch(requestParameters.pythonProductTemplateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductTemplatesApiProductTemplateResourceWipeAllProductEntriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTemplateResourceWipeAllProductEntries(requestParameters, options) {
            return localVarFp.productTemplateResourceWipeAllProductEntries(requestParameters.productTemplateRef, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ProductTemplatesApiFactory = ProductTemplatesApiFactory;
/**
 * ProductTemplatesApi - object-oriented interface
 * @export
 * @class ProductTemplatesApi
 * @extends {BaseAPI}
 */
class ProductTemplatesApi extends base_1.BaseAPI {
    /**
     *
     * @param {ProductTemplatesApiProductTemplateResourceCreateProductEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourceCreateProductEntry(requestParameters, options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourceCreateProductEntry(requestParameters.productTemplateRef, requestParameters.productEntryData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductTemplatesApiProductTemplateResourceDeleteProductEntriesByFilterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourceDeleteProductEntriesByFilter(requestParameters, options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourceDeleteProductEntriesByFilter(requestParameters.productTemplateRef, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductTemplatesApiProductTemplateResourceDeleteProductEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourceDeleteProductEntry(requestParameters, options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourceDeleteProductEntry(requestParameters.entryId, requestParameters.productTemplateRef, requestParameters.productEntryData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get data for bubble/scatter chart
     * @param {ProductTemplatesApiProductTemplateResourceGetBubbleChartDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourceGetBubbleChartData(requestParameters, options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourceGetBubbleChartData(requestParameters.id, requestParameters.colorAttr, requestParameters.nCount, requestParameters.xAttr, requestParameters.yAttr, requestParameters.zAttr, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductTemplatesApiProductTemplateResourceGetEntryIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourceGetEntryId(requestParameters, options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourceGetEntryId(requestParameters.ref, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductTemplatesApiProductTemplateResourceGetProductTemplateDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourceGetProductTemplateData(requestParameters, options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourceGetProductTemplateData(requestParameters.productTemplateRef, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductTemplatesApiProductTemplateResourceGetProductTemplateDataAsForeignKeysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourceGetProductTemplateDataAsForeignKeys(requestParameters, options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourceGetProductTemplateDataAsForeignKeys(requestParameters.productTemplateRef, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductTemplatesApiProductTemplateResourceGetProductTemplateDataPaginatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourceGetProductTemplateDataPaginated(requestParameters, options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourceGetProductTemplateDataPaginated(requestParameters.productTemplateRef, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.filter, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductTemplatesApiProductTemplateResourceGetProductTemplateInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourceGetProductTemplateInfo(requestParameters, options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourceGetProductTemplateInfo(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourceGetProductTemplateInfos(options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourceGetProductTemplateInfos(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductTemplatesApiProductTemplateResourcePatchProductEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourcePatchProductEntry(requestParameters, options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourcePatchProductEntry(requestParameters.entryId, requestParameters.productTemplateRef, requestParameters.productEntryData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductTemplatesApiProductTemplateResourceSignProductEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourceSignProductEntry(requestParameters, options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourceSignProductEntry(requestParameters.attribute, requestParameters.entryId, requestParameters.productTemplateRef, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductTemplatesApiProductTemplateResourceUpdateDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourceUpdateData(requestParameters = {}, options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourceUpdateData(requestParameters.updateProductEntriesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductTemplatesApiProductTemplateResourceUpdateDataBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourceUpdateDataBatch(requestParameters = {}, options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourceUpdateDataBatch(requestParameters.pythonProductTemplateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductTemplatesApiProductTemplateResourceWipeAllProductEntriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    productTemplateResourceWipeAllProductEntries(requestParameters, options) {
        return (0, exports.ProductTemplatesApiFp)(this.configuration).productTemplateResourceWipeAllProductEntries(requestParameters.productTemplateRef, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ProductTemplatesApi = ProductTemplatesApi;
//# sourceMappingURL=product-templates-api.js.map